var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinsuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 155,
    viewBox: "0 0 131 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00011188 57.7254C0.010894 59.2522 0.0757761 60.779 0.194379 62.3015C1.24024 75.5168 6.12439 88.1499 14.06 99.7832C18.5993 106.416 23.408 112.962 27.2033 119.88C29.0794 123.311 30.7079 126.836 31.8615 130.46C33.0691 134.233 33.8129 138.101 35.1715 141.844C37.2416 147.558 41.4465 153.031 48.8323 154.511C57.0806 156.16 65.5444 153.394 72.3587 149.861C80.1433 145.826 86.9904 140.598 93.3195 135.232C100.134 129.457 106.387 123.203 111.703 116.511L111.951 116.192C114.635 112.752 117.105 109.222 119.315 105.575C127.1 92.7703 131.887 78.368 130.863 64.3585C130 52.7403 125.967 41.1816 119.142 30.9117C115.606 25.5987 111.239 20.5303 106.117 16.0895C101.902 12.4278 95.9607 8.49015 90.7314 6.09337C77.9869 0.248039 63.0862 -1.56226 48.498 1.40585C32.3356 4.69859 18.3622 13.1117 10.1894 24.5935C3.07322 34.5962 -0.0214523 46.0174 0.00011188 57.4202V57.7254Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.083 86.4998H75.9163M56.083 94.9998H65.9997M85.833 49.6665H46.1663C45.4149 49.6665 44.6942 49.965 44.1629 50.4964C43.6315 51.0277 43.333 51.7484 43.333 52.4998V103.5C43.333 104.251 43.6315 104.972 44.1629 105.503C44.6942 106.035 45.4149 106.333 46.1663 106.333H85.833C86.5845 106.333 87.3051 106.035 87.8365 105.503C88.3678 104.972 88.6663 104.251 88.6663 103.5V52.4998C88.6663 51.7484 88.3678 51.0277 87.8365 50.4964C87.3051 49.965 86.5845 49.6665 85.833 49.6665V49.6665Z",
    stroke: "#1A1A1A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 62.4165L63.1667 73.7498L57.5 68.0832",
    stroke: "#1A1A1A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinsuccess);
export default __webpack_public_path__ + "static/media/pinsuccess.978adf20d86156a6433e0827ee74e1dc.svg";
export { ForwardRef as ReactComponent };